//import React, { useState, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';

import { AdminLayout } from './components/AdminLayout';
import { ParentLayout } from './components/ParentLayout';
import { Layout } from './components/Layout';
import './custom.css';

import { Areas } from "./Pages/Areas";
import { FreePlaces } from "./Pages/FreePlaces";
import { Home } from "./Pages/Home";
import { Login } from "./Pages/Login";
import { News } from "./Pages/News";
import { Parent } from "./Pages/Parent";
import { ParentLogin } from "./Pages/ParentLogin";
import { Ratings } from "./Pages/Ratings";
import { Register } from "./Pages/Register";
import { Rules } from "./Pages/Rules";
import { Grafik } from "./Pages/Grafik";
import { Schools } from "./Pages/Schools";
import { Foreigners } from "./Pages/Foreigners";
import Instructions from "./Pages/Instructions";

import { DashBoard } from "./admin/Pages/DashBoard";
import { AddressProvider } from "./contexts/AddressContext";

import { AdminAddMainPageNews } from "./admin/Pages/AdminAddMainPageNews";
import { AdminAllConfirmed } from "./admin/Pages/AdminAllConfirmed";
import { AdminAllEnrolled } from "./admin/Pages/AdminAllEnrolled";
import { AdminAllNewsList } from "./admin/Pages/AdminAllNewsList";
import { AdminAnnulReg } from "./admin/Pages/AdminAnnulReg";
import { AdminConfAdmission } from "./admin/Pages/AdminConfAdmission";
import { AdminDenialConfAdmission } from "./admin/Pages/AdminDenialConfAdmission";
import { AdminEditReg } from "./admin/Pages/AdminEditReg";
import { AdminPendingRating } from "./admin/Pages/AdminPendingRating";
import { AdminRankedChildrens } from "./admin/Pages/AdminRankedChildrens";
import { AdminUnsubscribe } from "./admin/Pages/AdminUnsubscribe";
import { AdminChangeSchedule } from "./admin/Pages/AdminChangeSchedule";
import { AdminAddEditRules } from "./admin/Pages/AdminAddEditRules";
import { AdminShowConfSystem } from "./admin/Pages/AdminShowConfSystem";
import { AdminShowVerSystem } from "./admin/Pages/AdminShowVerSystem";
import { AdminAddEditForeigners } from "./admin/Pages/AdminAddEditForeigners";

import 'primeicons/primeicons.css';
import { useContext } from 'react';
import { Logout } from './Pages/Logout';
import RegisterAddressResidence from './Pages/RegisterAddressResidence';
import { AuthContext } from './contexts/AuthContext';
import { ParameterContext, ParameterProvider } from './contexts/ParameterContext';
import { RegisterProvider } from './contexts/RegisterContext';
import { AdminAuthGuard } from './guards/AdminAuthGuard';
import { ParentAuthGuard } from './guards/ParentAuthGuard';
import { AdminMainWrapper } from './admin/components/AdminMainWrapper';
import { WishValidatorProvider } from './contexts/WishValidatorContext';
import EditAddressResidence from './Pages/EditAddressResidence';
import { EditManualAddressApplication } from './Pages/EditManualAddressApplication';
import { MunicipalityREgisterForm } from './admin/Pages/MunicipalityRegisterForm';
import { ForgPass } from '../src/Pages/ForgPass';
import { ParentChangePass } from '../src/Pages/ParentChangePass';
import { AdminProvider } from './contexts/AdminContext';
import { EditMunicipalityRegisterForm } from './admin/Pages/EditMunicipalityRegisterForm';
import { AdminArchive } from './admin/Pages/AdminArchive';
import NotFoundPage from '../src/components/NotFoundPage';
import DirectorFirstLogin from './admin/Pages/DirectorFirstLogin';
import { EditParent } from './Pages/EditParent';
import { ConfirmEmail } from './Pages/ConfirmEmail';
import { DigitalSignature } from './Pages/DigitalSignature';
import { ManageUsers } from './admin/Pages/ManageUsers';
import { BookOfActionsReference } from './admin/Pages/BookOfActionsReference';
import { TwoFAProvider } from './contexts/TwoFAContext';
import DirectorApplicationsGuard from './admin/components/DirectorApplicationsGuard';


export default function App() {
    const { parameters } = useContext(ParameterContext);
    const { user } = useContext(AuthContext);
    const mainRegForm = parameters.nomParameters && parameters.nomParameters.length > 0 && parameters.nomParameters.find(x => x.param_name == 'MAIN_REGISTER_FORM')
    const testRegParam = parameters.nomParameters && parameters.nomParameters.length > 0 && parameters.nomParameters.find(x => x.param_name == 'TEST_REG');
    const parentLoginParam = parameters.nomParameters && parameters.nomParameters.length > 0 && parameters.nomParameters.find(x => x.param_name == 'HIDE_PARENT_LOGIN');
    const dirRegisterForm = parameters.nomParameters && parameters.nomParameters.length > 0 && parameters.nomParameters.find(x => x.param_name == 'DIRECTOR_REGISTER_FORM');
    const dirDisableChildData = parameters.nomParameters && parameters.nomParameters.length > 0 && parameters.nomParameters.find(x => x.param_name == 'DIR_DISABLE_CIHLD_DATA');

    //console.log(dirDisableChildData)

    if (Array.isArray(parameters)) {
        return null;
    }

    const RenderAdminModuleRegisterForm = () => {
        if (user.role == 'Director') {
            if (dirRegisterForm.value == 1) {
                return <Register />
            } else if (dirRegisterForm.value == 2) {
                return <MunicipalityREgisterForm />
            } else if (dirRegisterForm.value == 0) {
                return <RegisterAddressResidence />
            }
        } else if (user.role == 'Municipality') {
            if (user.changeGrao == 1 || mainRegForm.value == 2) { //user.changeGrao is with priority (not role) !!
                return <MunicipalityREgisterForm />
            } else if (mainRegForm.value == 0) {
                return <RegisterAddressResidence />
            } else if (mainRegForm.value == 1) {
                return <Register />
            }
        } else {
            if (user.changeGrao == 1 || mainRegForm.value == 2) {
                return <MunicipalityREgisterForm />
            } else if (mainRegForm.value == 0) {
                return <RegisterAddressResidence />
            } else if (mainRegForm.value == 1) {
                return <Register />
            } 
        }
    }

    const RenderAdminModuleEditRegisterForm = () => {
        if (user.role == 'Director') {
            if (dirRegisterForm.value == 1) {
                return <EditManualAddressApplication />
            } else if (dirRegisterForm.value == 2) {
                return <EditMunicipalityRegisterForm />
            } else if (dirRegisterForm.value == 0) {
                return <EditAddressResidence />
            }
        } else if (user.role == 'Municipality') {
            if (user.changeGrao == 1 || mainRegForm.value == 2) { //user.changeGrao is with priority (not role) !!
                return <EditMunicipalityRegisterForm />
            } else if (mainRegForm.value == 0) {
                return <EditAddressResidence />
            } else if (mainRegForm.value == 1) {
                return <EditManualAddressApplication />
            }
        } else {
            if (user.changeGrao == 1 || mainRegForm.value == 2) {
                return <EditMunicipalityRegisterForm />
            } else if (mainRegForm.value == 0) {
                return <EditAddressResidence />
            } else if (mainRegForm.value == 1) {
                return <EditManualAddressApplication />
            }
        }
    }

    return (

        <>
            <Routes>
                {/* Public Routes */}
                <Route
                    path="/*"
                    element={
                        <Layout>
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/news" element={<News />} />
                                <Route path="/instructions" element={<Instructions />} />
                                <Route path="/areas" element={<Areas />} />
                                <Route path="/ratings" element={<Ratings />} />
                                <Route
                                    path={testRegParam.value == 0 ? 'register' : testRegParam.value}
                                    element={
                                        <AddressProvider>
                                            <WishValidatorProvider>
                                                <RegisterProvider>
                                                    {mainRegForm &&
                                                        (mainRegForm.value == 0 ? <RegisterAddressResidence />
                                                            : mainRegForm.value == 1 ? <Register />
                                                                : <MunicipalityREgisterForm />)
                                                    }
                                                </RegisterProvider>
                                            </WishValidatorProvider>
                                        </AddressProvider>
                                    }
                                />
                                <Route path="/confirmEmail" element={<ConfirmEmail />} />
                                <Route path="/digitalSignature" element={<DigitalSignature />} />
                                <Route path="/rules" element={<Rules />} />
                                <Route path="/grafik" element={<Grafik />} />
                                <Route path="/schools" element={<Schools />} />
                                <Route path="/free-places" element={<FreePlaces />} />
                                {/*<Route path="/foreigners" element={<Foreigners />} />*/}
                                <Route path="/parent/main" element={<Parent />} />
                                <Route path={parentLoginParam.value == 0 ? '/parent-login' : parentLoginParam.value} element={
                                    <TwoFAProvider>
                                        <ParentLogin />
                                    </TwoFAProvider>
                                } />
                                <Route path="/forgotten-password" element={<ForgPass />} />
                                <Route path="*" element={<NotFoundPage />} />
                            </Routes>
                        </Layout>
                    }
                />

                <Route element={<ParentAuthGuard />}>
                    <Route
                        path="/parent/*"
                        element={
                            <RegisterProvider>
                                <ParentLayout>
                                    <ParameterProvider>
                                        <WishValidatorProvider>
                                            <Routes>
                                                <Route path="/" element={<Parent />} />
                                                <Route
                                                    path={testRegParam.value == 0 ? 'register' : testRegParam.value}
                                                    element={
                                                        <AddressProvider>
                                                            <WishValidatorProvider>
                                                                <RegisterProvider>
                                                                    {mainRegForm &&
                                                                        (mainRegForm.value == 0 ? <RegisterAddressResidence />
                                                                            : mainRegForm.value == 1 ? <Register />
                                                                                : <MunicipalityREgisterForm />)
                                                                    }
                                                                </RegisterProvider>
                                                            </WishValidatorProvider>
                                                        </AddressProvider>
                                                    }
                                                />
                                                <Route path="/edit/:regId" element={
                                                    <AddressProvider>
                                                        {mainRegForm &&
                                                            (mainRegForm.value == 0 ? <EditAddressResidence />
                                                                : mainRegForm.value == 1 ? <EditManualAddressApplication />
                                                                    : <EditMunicipalityRegisterForm />)
                                                        }
                                                    </AddressProvider>
                                                }
                                                />
                                                <Route path="/profile/:id" element={<EditParent />} />
                                                <Route path="/change-password" element={<ParentChangePass />} />
                                                <Route path="/logout" element={<Logout />} />
                                                <Route path="*" element={<NotFoundPage />} />
                                            </Routes>
                                        </WishValidatorProvider>
                                    </ParameterProvider>
                                </ParentLayout>
                            </RegisterProvider>
                        }
                    />
                </Route>

                <Route path="schadm/login" element={
                    <TwoFAProvider>
                        <Login />
                    </TwoFAProvider>
                } />
                <Route path="schadm/firstLogin" element={<DirectorFirstLogin />} />

                <Route element={<AdminAuthGuard />}>
                    <Route
                        path="/schadm/*"
                        element={
                            <AdminLayout>
                                <ParameterProvider>
                                    <RegisterProvider>

                                        <Routes>
                                            <Route path="/" element={
                                                <AdminProvider>
                                                    <DashBoard />
                                                </AdminProvider>
                                            } />
                                            <Route path="/home" element={
                                                <AdminProvider>
                                                    <DashBoard />
                                                </AdminProvider>
                                            } />

                                            <Route
                                                path={'register'}
                                                element={
                                                   <DirectorApplicationsGuard>
                                                        <AddressProvider>
                                                        <RegisterProvider>
                                                            <AdminMainWrapper>
                                                                <WishValidatorProvider>
                                                                    {RenderAdminModuleRegisterForm()}
                                                                </WishValidatorProvider>
                                                            </AdminMainWrapper>
                                                        </RegisterProvider>
                                                        </AddressProvider>
                                                    </DirectorApplicationsGuard>
                                                }
                                            />
                                            <Route path="/register/municipality" element={
                                                <DirectorApplicationsGuard>
                                                <AddressProvider>
                                                    <RegisterProvider>
                                                        <AdminMainWrapper>
                                                            <WishValidatorProvider>
                                                                <MunicipalityREgisterForm />
                                                            </WishValidatorProvider>
                                                        </AdminMainWrapper>
                                                    </RegisterProvider>
                                                    </AddressProvider>
                                                  </DirectorApplicationsGuard>
                                            } />
                                            <Route path="/editreg" element={
                                                <DirectorApplicationsGuard>
                                                    <AdminProvider>
                                                        <AdminEditReg />
                                                    </AdminProvider>
                                                </DirectorApplicationsGuard>
                                            } />
                                            <Route path="/annul-reg" element={
                                                <DirectorApplicationsGuard>
                                                    <AdminProvider>
                                                        <AdminAnnulReg />
                                                    </AdminProvider>
                                                 </DirectorApplicationsGuard>
                                            } />
                                            <Route path="/conf-admission" element={
                                                <AdminProvider>
                                                    <AdminConfAdmission />
                                                </AdminProvider>

                                            } />
                                            <Route path="/denial-admission" element={
                                                <AdminProvider>
                                                    <AdminDenialConfAdmission />
                                                </AdminProvider>

                                            } />
                                            <Route path="/unsubscribe" element={
                                                <AdminProvider>
                                                    <AdminUnsubscribe />
                                                </AdminProvider>

                                            } />

                                            <Route path="/archive" element={
                                                <AdminProvider>
                                                    <AdminArchive />
                                                </AdminProvider>
                                            } />

                                            <Route path="/edit/:regId" element={
                                                <AdminMainWrapper>
                                                    <WishValidatorProvider>
                                                        <AddressProvider>
                                                            {RenderAdminModuleEditRegisterForm()}
                                                        </AddressProvider>
                                                    </WishValidatorProvider>
                                                </AdminMainWrapper>
                                            }
                                            />

                                            <Route path="/all-conf" element={<AdminAllConfirmed />} />
                                            <Route path="/main-page-news" element={<AdminAddMainPageNews />} />
                                            <Route path="/all-enroled" element={<AdminAllEnrolled />} />
                                            <Route path="/all-news" element={<AdminAllNewsList />} />
                                            <Route path="/pending-rating" element={<AdminPendingRating />} />
                                            <Route path="/foreigners" element={<AdminAddEditForeigners />} />
                                            <Route path="/ranked-childrens" element={<AdminRankedChildrens />} />
                                            <Route path="/bookOfActions" element={<BookOfActionsReference />} />
                                            <Route path="/add-rules" element={<AdminAddEditRules />} />
                                            <Route path="/change-schedule" element={<AdminChangeSchedule />} />
                                            <Route path="/show-conf-system" element={<AdminShowConfSystem />} />
                                            <Route path="/show-sys-version" element={<AdminShowVerSystem />} />
                                            <Route path="/manageUsers" element={<ManageUsers />} />
                                            <Route path="/logout" element={<Logout />} />
                                            <Route path="*" element={
                                                <AdminMainWrapper>
                                                    <NotFoundPage />
                                                </AdminMainWrapper>
                                            } />
                                        </Routes>
                                    </RegisterProvider>
                                </ParameterProvider>
                            </AdminLayout>
                        }
                    />
                </Route>

            </Routes >
        </>

    );

}
